module.exports = __webpack_public_path__ + "static/media/stackoverflow.58d76e6b.svg";